// extracted by mini-css-extract-plugin
export var copyableField = "_p8-4";
export var customerBadge = "_p8-0";
export var customerInfoTitle = "_p8-2";
export var details = "_p8-1";
export var dropdownContainer = "_p8-5";
export var dropdownImage = "_p8-6";
export var editAssigneeForm = "_p8-a";
export var editButton = "_p8-3";
export var email = "_p8-7";
export var hidden = "_p8-d";
export var input = "_p8-8";
export var saveButton = "_p8-b";
export var shopifyIcon = "_p8-c";
export var suggestionBadge = "_p8-e";
export var suggestionText = "_p8-f";
export var username = "_p8-9";